import React, { useState } from 'react';
import { Minus, Plus } from 'lucide-react';
type FaqItem = {
  question: string;
  answer: string;
};
const FAQS: FaqItem[] = [{
  question: '¿Qué es exactamente Sin Azúcar Club?',
  answer: 'Es una app para organizar tus comidas sin azúcar en un solo lugar. Incluye más de 300 recetas, planificador semanal, lista de compras automática, matching con tu despensa y seguimiento de progreso.'
}, {
  question: '¿Cómo recibo el acceso?',
  answer: 'Apenas confirmado el pago recibís un email con el link de acceso y la contraseña. El acceso es inmediato.'
}, {
  question: '¿Funciona en el celular?',
  answer: 'Sí. Podés usar Sin Azúcar Club desde el celular, la tablet o la computadora. Solo necesitás conexión a internet y un navegador.'
}, {
  question: '¿Las recetas son todas sin azúcar?',
  answer: 'Sí. La app reúne recetas sin azúcar para distintos momentos del día y te permite filtrarlas para elegir más rápido según lo que necesitás cocinar.'
}, {
  question: '¿El acceso tiene suscripción?',
  answer: 'No. Hacés un único pago de $19.990 y accedés de por vida a la app desde cualquier dispositivo.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="scroll-mt-8 bg-white px-6 py-16 lg:px-12 lg:py-20" data-id="element-114" data-mp="1fnuf3jw6nsne">
      <div className="mx-auto max-w-3xl" data-id="element-115" data-mp="11xih54cx2zoc">
        <p className="mb-3 text-center text-sm font-extrabold tracking-[0.16em] text-[#6E8A42]" data-id="element-116" data-mp="11vnzbywxznoh">TENÉ TODO CLARO</p>
        <h2 className="mb-10 text-center text-3xl font-extrabold tracking-tight text-[#183717] md:text-5xl" data-id="element-117" data-mp="16pa4l60s0pa9">PREGUNTAS FRECUENTES</h2>

        <div className="space-y-3" data-id="element-118" data-mp="wxw5v0gnfti6">
          {FAQS.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className={`overflow-hidden rounded-2xl border transition-colors duration-300 ${isOpen ? 'border-[#B9CD8A] bg-[#EEF2DF]' : 'border-[#31502A]/10 bg-[#FBF8F1]'}`} data-id="element-119" data-mp="iywjjzglzqp6" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#6E8A42]" data-id="element-120" data-mp="2po7wnefi70ub">
                  <span className="text-lg font-extrabold text-[#183717]" data-id="element-121" data-mp="38k6ff4mojmoo">{faq.question}</span>
                  <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${isOpen ? 'bg-[#6E8A42] text-white' : 'bg-white text-[#36572A]'}`} data-id="element-122" data-mp="33ng1amufr15w">
                    {isOpen ? <Minus className="h-5 w-5" strokeWidth={3} aria-hidden="true" data-id="element-123" data-mp="2ukon4fa6drak" /> : <Plus className="h-5 w-5" strokeWidth={3} aria-hidden="true" data-id="element-124" data-mp="1n7wmnppl18iz" />}
                  </span>
                </button>
                <div className={`grid transition-all duration-300 ease-in-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-125" data-mp="1j5i1v02cryp2">
                  <div className="overflow-hidden" data-id="element-126" data-mp="3us3jl1x7jr2m">
                    <p className="px-6 pb-5 font-medium leading-relaxed text-[#183717]/70" data-id="element-127" data-mp="2qx6vvtmeo7v">{faq.answer}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}